<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <div class="switch-button">
                    <label class="switch-all-campaign">
                        <input type="checkbox" @click="switchAllCampaignsStatus" :checked="!sendingStatus" name="switch-all-campaign-checkbox">
                        <span class="slider round"></span>
                    </label>
                    <span class="switch-button-text">Désactiver / Activer toutes les campagnes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <messages :is-fetching="isFetching" :isPaused="sendingStatus" :is-full="true" @show="onShow" @show-delete-campaign-modal="showDeleteCampaignModal" :messages="all">Aucun envois effectués</messages>
      </div>
      <modal
        id="confirm-campaign-delete"
        @accept="confirmDeleteCampaign"
        accept-button
        accept-button-label="Supprimer"
        cancel-button
        cancel-button-label="Non"
      >
        Etes-vous certain de vouloir supprimer cette campagne ?
      </modal>
      <modal id="delete-campaign-pending-message" data-backdrop="static" data-keyboard="false">
        <p class="text-center">Suppression de la campagne en cours.<br>Ne fermez pas votre navigateur.</p>
        <div class="text-center">
          <loading-progress
            indeterminate
            hide-background
            size="32"
            rotate
            fillDuration="2"
            rotationDuration="1"
          />
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Messages from '@/components/Messages';
import Modal from '@/components/Modal';

export default {
  data() {
    return {
      campaignToDelete: ''
    };
  },
  components: { Messages, Modal },
  computed: {
    ...mapGetters({
      all: 'campaigns/campaigns',
      isFetching: 'campaigns/isFetching'
    }),
    sendingStatus() {
      return this.$store.state.campaigns.globalSendingStatus;
    }
  },
  methods: {
    ...mapActions({
      getAll: 'campaigns/getAll',
      getGlobalSendingStatus: 'campaigns/getGlobalSendingStatus',
      toggleGlobalSendingStatus: 'campaigns/toggleGlobalSendingStatus',
      deleteCampaign: 'campaigns/delete'
    }),
    switchAllCampaignsStatus() {
      this.toggleGlobalSendingStatus();
    },
    onShow({ id }) {
      this.$router.push({ name: 'report', params: { campaignId: id } });
    },
    showDeleteCampaignModal(campaign) {
      this.campaignToDelete = campaign;
      this.$jQuery('#confirm-campaign-delete').modal('show');
    },
    confirmDeleteCampaign() {
      this.$jQuery('#confirm-campaign-delete').modal('hide');
      this.$jQuery('#delete-campaign-pending-message').modal('show');
      document.body.classList.add('deletion-in-progress');

      this.deleteCampaign(this.campaignToDelete.id)
        .catch(error => setTimeout(() => this.$eventBus.$emit('fetch-data-error', error), 600))
        .finally(() => {
          setTimeout(() => this.$jQuery('#delete-campaign-pending-message').modal('hide'), 500);
          document.body.classList.remove('deletion-in-progress');
        });
    }
  },
  mounted() {
    this.getAll().catch(() => this.$eventBus.$emit('fetch-data-error'));
    this.getGlobalSendingStatus().catch(() => this.$eventBus.$emit('fetch-data-error'));
  }
};
</script>
<style>
.modal-scroll-area {
  position: relative;
}

#edit-user .modal-body {
  padding: 0;
}
</style>
